const locationsDe = [
  {
    "id": 29505,
    "city": "Amman",
    "address": "",
    "code": "AMM",
    "value": "AMM",
    "destination_translations": "",
    "language": "de",
    "country": "Jordanien"
  },
  {
    "id": 29496,
    "city": "Amsterdam",
    "address": "",
    "code": "AMS",
    "value": "AMS",
    "destination_translations": "",
    "language": "de",
    "country": "Niederlande"
  },
  {
    "id": 29487,
    "city": "Ankara",
    "address": "",
    "code": "ESB",
    "value": "ESB",
    "destination_translations": "",
    "language": "de",
    "country": "Türkei"
  },
  {
    "id": 29478,
    "city": "Antalya",
    "address": "",
    "code": "AYT",
    "value": "AYT",
    "destination_translations": "",
    "language": "de",
    "country": "Türkei"
  },
  {
    "id": 29473,
    "city": "Atena",
    "address": "",
    "code": "ATH",
    "value": "ATH",
    "destination_translations": "",
    "language": "de",
    "country": "Griechenland"
  },
  {
    "id": 29464,
    "city": "Barcelona",
    "address": "",
    "code": "BCN",
    "value": "BCN",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 29459,
    "city": "Bari",
    "address": "",
    "code": "BRI",
    "value": "BRI",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29448,
    "city": "Beirut",
    "address": "",
    "code": "BEY",
    "value": "BEY",
    "destination_translations": "",
    "language": "de",
    "country": "Libanon"
  },
  {
    "id": 29438,
    "city": "Belgrad",
    "address": "",
    "code": "BEG",
    "value": "BEG",
    "destination_translations": "",
    "language": "de",
    "country": "Serbien"
  },
  {
    "id": 29424,
    "city": "Bilbao",
    "address": "",
    "code": "BIO",
    "value": "BIO",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 29415,
    "city": "Bodrum",
    "address": "",
    "code": "BJV",
    "value": "BJV",
    "destination_translations": "",
    "language": "de",
    "country": "Türkei"
  },
  {
    "id": 29408,
    "city": "Bologna",
    "address": "",
    "code": "BLQ",
    "value": "BLQ",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29398,
    "city": "Brindisi",
    "address": "",
    "code": "BDS",
    "value": "BDS",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29393,
    "city": "Bruxelles",
    "address": "",
    "code": "BRU",
    "value": "BRU",
    "destination_translations": "",
    "language": "de",
    "country": "Belgien"
  },
  {
    "id": 29383,
    "city": "Bucuresti",
    "address": "",
    "code": "OTP",
    "value": "OTP",
    "destination_translations": "București\nBucuresti\nBucharest\nBucarest\nBukarest\nHenri Coanda\nHenri Coandă\nRoumanie\nRomânia\nRomania",
    "language": "de",
    "country": "Rumänien"
  },
  {
    "id": 29373,
    "city": "Budapesta",
    "address": "",
    "code": "BUD",
    "value": "BUD",
    "destination_translations": "",
    "language": "de",
    "country": "Ungarn"
  },
  {
    "id": 29355,
    "city": "Cairo",
    "address": "",
    "code": "CAI",
    "value": "CAI",
    "destination_translations": "",
    "language": "de",
    "country": "Ägypten"
  },
  {
    "id": 29346,
    "city": "Catania",
    "address": "",
    "code": "CTA",
    "value": "CTA",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  // {
  //   "id": 29341,
  //   "city": "Chisinau",
  //   "address": "",
  //   "code": "KIV",
  //   "value": "KIV",
  //   "destination_translations": "",
  //   "language": "de",
  //   "country": "Moldau"
  // },
  {
    "id": 29332,
    "city": "Cluj-Napoca",
    "address": "",
    "code": "CLJ",
    "value": "CLJ",
    "destination_translations": "",
    "language": "de",
    "country": "Rumänien"
  },
  {
    "id": 29318,
    "city": "Detroit",
    "address": "",
    "code": "DTW",
    "value": "DTW",
    "destination_translations": "",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 29307,
    "city": "Frankfurt",
    "address": "",
    "code": "FRA",
    "value": "FRA",
    "destination_translations": "",
    "language": "de",
    "country": "Deutschland"
  },
  {
    "id": 29298,
    "city": "Genova",
    "address": "",
    "code": "GOA",
    "value": "GOA",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29293,
    "city": "Gran Canaria",
    "address": "",
    "code": "LPA",
    "value": "LPA",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 29284,
    "city": "Iasi",
    "address": "",
    "code": "IAS",
    "value": "IAS",
    "destination_translations": "Iași\nIaşi\nIasi\nRoumanie\nRomânia\nRomania",
    "language": "de",
    "country": "Rumänien"
  },
  {
    "id": 29275,
    "city": "Istanbul",
    "address": "",
    "code": "IST",
    "value": "IST",
    "destination_translations": "",
    "language": "de",
    "country": "Türkei"
  },
  {
    "id": 29270,
    "city": "Izmir",
    "address": "",
    "code": "ADB",
    "value": "ADB",
    "destination_translations": "",
    "language": "de",
    "country": "Türkei"
  },
  {
    "id": 29259,
    "city": "Milan",
    "address": "",
    "code": "LIN",
    "value": "LIN",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29254,
    "city": "Lisabona",
    "address": "",
    "code": "LIS",
    "value": "LIS",
    "destination_translations": "",
    "language": "de",
    "country": "Portugal"
  },
  {
    "id": 29248,
    "city": "Londra",
    "address": "",
    "code": "LHR",
    "value": "LHR",
    "destination_translations": "",
    "language": "de",
    "country": "Vereinigtes Königreich"
  },
  {
    "id": 29243,
    "city": "Lyon",
    "address": "",
    "code": "LYS",
    "value": "LYS",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29238,
    "city": "Madrid",
    "address": "",
    "code": "MAD",
    "value": "MAD",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 29233,
    "city": "Malaga",
    "address": "",
    "code": "AGP",
    "value": "AGP",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 29228,
    "city": "Marsilia",
    "address": "",
    "code": "MRS",
    "value": "MRS",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29223,
    "city": "Montpellier",
    "address": "",
    "code": "MPL",
    "value": "MPL",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29208,
    "city": "Napoli",
    "address": "",
    "code": "NAP",
    "value": "NAP",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29198,
    "city": "Nisa",
    "address": "",
    "code": "NCE",
    "value": "NCE",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29193,
    "city": "Oradea",
    "address": "",
    "code": "OMR",
    "value": "OMR",
    "destination_translations": "",
    "language": "de",
    "country": "Rumänien"
  },
  {
    "id": 29188,
    "city": "Palermo",
    "address": "",
    "code": "PMO",
    "value": "PMO",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29183,
    "city": "Palma de Mallorca",
    "address": "",
    "code": "PMI",
    "value": "PMI",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 29178,
    "city": "Paris",
    "address": "",
    "code": "CDG",
    "value": "CDG",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29173,
    "city": "Pau",
    "address": "Pau Pyrénées Airport",
    "code": "PUF",
    "value": "PUF",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29168,
    "city": "Praga",
    "address": "",
    "code": "PRG",
    "value": "PRG",
    "destination_translations": "",
    "language": "de",
    "country": "Tschechien"
  },
  {
    "id": 29163,
    "city": "Riad",
    "address": "",
    "code": "RUH",
    "value": "RUH",
    "destination_translations": "",
    "language": "de",
    "country": "Saudi-Arabien"
  },
  {
    "id": 29158,
    "city": "Riga",
    "address": "",
    "code": "RIX",
    "value": "RIX",
    "destination_translations": "",
    "language": "de",
    "country": "Lettland"
  },
  {
    "id": 29153,
    "city": "Roma",
    "address": "",
    "code": "FCO",
    "value": "FCO",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29148,
    "city": "Salonic",
    "address": "",
    "code": "SKG",
    "value": "SKG",
    "destination_translations": "",
    "language": "de",
    "country": "Griechenland"
  },
  {
    "id": 29138,
    "city": "Sofia",
    "address": "",
    "code": "SOF",
    "value": "SOF",
    "destination_translations": "",
    "language": "de",
    "country": "Bulgarien"
  },
  {
    "id": 29133,
    "city": "Strasbourg",
    "address": "",
    "code": "SXB",
    "value": "SXB",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29128,
    "city": "Suceava",
    "address": "",
    "code": "SCV",
    "value": "SCV",
    "destination_translations": "",
    "language": "de",
    "country": "Rumänien"
  },
  {
    "id": 29123,
    "city": "Tallin",
    "address": "",
    "code": "TLL",
    "value": "TLL",
    "destination_translations": "",
    "language": "de",
    "country": "Estland"
  },
  {
    "id": 29118,
    "city": "Tampere",
    "address": "",
    "code": "TMP",
    "value": "TMP",
    "destination_translations": "",
    "language": "de",
    "country": "Finnland"
  },
  {
    "id": 29113,
    "city": "Tel Aviv",
    "address": "",
    "code": "TLV",
    "value": "TLV",
    "destination_translations": "",
    "language": "de",
    "country": "Israel"
  },
  {
    "id": 29108,
    "city": "Tenerife",
    "address": "",
    "code": "TFN",
    "value": "TFN",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 29103,
    "city": "Timisoara",
    "address": "",
    "code": "TSR",
    "value": "TSR",
    "destination_translations": "",
    "language": "de",
    "country": "Rumänien"
  },
  {
    "id": 29098,
    "city": "Torino",
    "address": "",
    "code": "TRN",
    "value": "TRN",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29093,
    "city": "Toulouse",
    "address": "",
    "code": "TLS",
    "value": "TLS",
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 29083,
    "city": "Venetia",
    "address": "",
    "code": "VCE",
    "value": "VCE",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 29078,
    "city": "Viena",
    "address": "",
    "code": "VIE",
    "value": "VIE",
    "destination_translations": "",
    "language": "de",
    "country": "Österreich"
  },
  {
    "id": 29073,
    "city": "Vilnius",
    "address": "",
    "code": "VNO",
    "value": "VNO",
    "destination_translations": "",
    "language": "de",
    "country": "Litauen"
  },
  {
    "id": 29027,
    "city": "Washington",
    "address": "",
    "code": "IAD",
    "value": "IAD",
    "destination_translations": "",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 29064,
    "city": "Baia Mare",
    "address": "",
    "code": "BAY",
    "value": "BAY",
    "destination_translations": "",
    "language": "de",
    "country": "Rumänien"
  },
  {
    "id": 7909,
    "city": "Alghero",
    "address": "Alghero Airport",
    "code": "AHO",
    "value": "AHO",
    "destination_translations": "",
    "language": "de",
    "country": "Italia"
  },
  {
    "id": 45608,
    "city": "A Coruna",
    "address": "A Coruna Airport",
    "code": "LCG",
    "value": "LCG",
    "destination_translations": "La Coruna\nLa Coruña\nA Coruña\nA Coruña Airport\nA Coruña Airport",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 34306,
    "city": "New York",
    "address": "",
    "code": "JFK",
    "value": "JFK",
    "destination_translations": "",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 32947,
    "city": "Tirana",
    "address": "Flughafen Tirana Nënë Tereza",
    "code": "TIA",
    "value": "TIA",
    "destination_translations": "Tirana\nTiranë\nRinas\nAlbania\nShqipëri",
    "language": "de",
    "country": "Albanien"
  },
  {
    "id": 44864,
    "city": "Dublin",
    "address": "Dublin Airport",
    "code": "DUB",
    "value": "DUB",
    "destination_translations": "",
    "language": "de",
    "country": "Irland"
  },
  {
    "id": 44872,
    "city": "Copenhaga",
    "address": "Copenhagen Airport",
    "code": "CPH",
    "value": "CPH",
    "destination_translations": "",
    "language": "de",
    "country": "Dänemark"
  },
  {
    "id": 44879,
    "city": "Gothenburg",
    "address": "Göteborg Landvetter Airport",
    "code": "GOT",
    "value": "GOT",
    "destination_translations": "",
    "language": "de",
    "country": "Schweden"
  },
  {
    "id": 44886,
    "city": "Stockholm",
    "address": "Stockholm Arlanda Airport",
    "code": "ARN",
    "value": "ARN",
    "destination_translations": "",
    "language": "de",
    "country": "Schweden"
  },
  {
    "id": 45585,
    "city": "Florenta",
    "address": "Amerigo Vespucci Airport",
    "code": "FLR",
    "value": "FLR",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 45596,
    "city": "Reggio Calabria",
    "address": "Reggio Calabria Airport",
    "code": "REG",
    "value": "REG",
    "destination_translations": "",
    "language": "de",
    "country": "Italien"
  },
  {
    "id": 45602,
    "city": "Porto",
    "address": "Francisco Sá Carneiro Airport",
    "code": "OPO",
    "value": "OPO",
    "destination_translations": "",
    "language": "de",
    "country": "Portugal"
  },
  {
    "id": 45614,
    "city": "Vigo",
    "address": "Vigo Airport",
    "code": "VGO",
    "value": "VGO",
    "destination_translations": "",
    "language": "de",
    "country": "Spanien"
  },
  {
    "id": 45606,
    "city": "Paris",
    "address": "Flughafen Paris-Orly",
    "code": "ORY",
    "value": "ORY", 
    "destination_translations": "",
    "language": "de",
    "country": "Frankreich"
  },
  {
    "id": 45607,
    "city": "Chișinău",
    "address": "Flughafen Chișinău",
    "code": "RMO",
    "value": "RMO",
    "destination_translations": "",
    "language": "de",
    "country": "Moldawien"
  },
  {
    "id": 46001,
    "city": "Calgary",
    "address": "Flughafen Calgary",
    "code": "YYC",
    "value": "YYC",
    "destination_translations": "Calgary\nCalgary Airport\nCanada",
    "language": "de",
    "country": "Kanada"
  },
  {
    "id": 46002,
    "city": "Toronto",
    "address": "Flughafen Toronto-Pearson",
    "code": "YYZ",
    "value": "YYZ",
    "destination_translations": "Toronto\nToronto Pearson\nPearson\nCanada",
    "language": "de",
    "country": "Kanada"
  },
  {
    "id": 46003,
    "city": "Vancouver",
    "address": "Flughafen Vancouver",
    "code": "YVR",
    "value": "YVR",
    "destination_translations": "Vancouver\nVancouver Airport\nCanada",
    "language": "de",
    "country": "Kanada"
  },
  {
    "id": 46004,
    "city": "Boston",
    "address": "Flughafen Boston-Logan",
    "code": "BOS",
    "value": "BOS",
    "destination_translations": "Boston\nLogan\nBoston Airport\nUnited States\nUSA",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 46005,
    "city": "Las Vegas",
    "address": "Harry Reid International Airport",
    "code": "LAS",
    "value": "LAS",
    "destination_translations": "Las Vegas\nHarry Reid\nMcCarran\nUnited States\nUSA",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 46006,
    "city": "Los Angeles",
    "address": "Flughafen Los Angeles",
    "code": "LAX",
    "value": "LAX",
    "destination_translations": "Los Angeles\nLAX\nUnited States\nUSA",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 46007,
    "city": "Seattle",
    "address": "Flughafen Seattle-Tacoma",
    "code": "SEA",
    "value": "SEA",
    "destination_translations": "Seattle\nSeattle-Tacoma\nSeaTac\nUnited States\nUSA",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 46008,
    "city": "San Francisco",
    "address": "Flughafen San Francisco",
    "code": "SFO",
    "value": "SFO",
    "destination_translations": "San Francisco\nSFO\nUnited States\nUSA",
    "language": "de",
    "country": "Vereinigte Staaten"
  },
  {
    "id": 46009,
    "city": "Anchorage",
    "address": "Flughafen Anchorage",
    "code": "ANC",
    "value": "ANC",
    "destination_translations": "Anchorage\nTed Stevens\nAlaska\nUnited States\nUSA",
    "language": "de",
    "country": "Vereinigte Staaten"
  }
];

export default locationsDe;